import { render } from "./BaseTreeViewArticlesSorted.vue?vue&type=template&id=2239bfda&scoped=true"
import script from "./BaseTreeViewArticlesSorted.vue?vue&type=script&lang=js"
export * from "./BaseTreeViewArticlesSorted.vue?vue&type=script&lang=js"

import "./BaseTreeViewArticlesSorted.vue?vue&type=style&index=0&id=2239bfda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2239bfda"]])

export default __exports__